class CompareSection {
  constructor() {
    this.wrapper = document.getElementById('compare');
    if (!this.wrapper) return;

    this.swiperEl = this.wrapper.querySelector('.swiper');
    this.swiper = null;

    this.collapse = document.getElementById('collapse-compare');

    this.init();
  }
  
  init() {
    this.initSwiper();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('resize', () => {
      this.equalizeRows();
    });

    this.collapse.addEventListener('show.bs.collapse', (e) => {
      this.wrapper.classList.add('show');
    });

    this.collapse.addEventListener('shown.bs.collapse', (e) => {
      this.equalizeRows();
    });

    this.collapse.addEventListener('hide.bs.collapse', (e) => {
      this.wrapper.classList.remove('show');
    });
  }

  initSwiper() {
    if (!this.swiperEl || this.swiper) return;

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 6,
      allowTouchMove: true,
      loop: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        clickable: true
      },
      on: {
        init: () => {
          this.equalizeRows();
        }
      },
      breakpoints: {
        1400: { slidesPerView: 3 }
      }
    });
  }

  equalizeRows() {
    for (let i = 1; i <= 9; i++) {
      this.equalizeHeight(`.compare__table-row-${i}`);
    }
  }

  equalizeHeight(selector) {
    const elements = this.wrapper.querySelectorAll(selector);
    if (!elements.length) return;

    let maxHeight = 0;

    elements.forEach((el) => {
      el.style.height = '';
    });
    
    elements.forEach((el) => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });
    
    elements.forEach((el) => {
      el.style.height = `${maxHeight}px`;
    });
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
	new CompareSection();
});